import { useMemo, useState } from "react";
import { X } from "@phosphor-icons/react";
import { GIF_LIBRARY } from "./constants";

export default function GifPicker({ open, onClose, onSend }) {
  const [customGifUrl, setCustomGifUrl] = useState("");
  const [brokenGifs, setBrokenGifs] = useState({});

  // Cache the filtered library — only recompute when a preset breaks
  const visibleGifs = useMemo(
    () => GIF_LIBRARY.filter((g) => !brokenGifs[g.url]),
    [brokenGifs]
  );

  if (!open) return null;

  return (
    <div className="absolute bottom-full left-2 right-2 mb-2 bg-neutral-950/98 backdrop-blur-md border border-white/15 rounded-2xl shadow-2xl p-3 z-40 max-h-72 overflow-y-auto" data-testid="chat-gif-picker">
      <div className="flex items-center justify-between mb-2">
        <div className="text-xs font-semibold text-white/80 flex items-center gap-1.5">
          <span className="text-[10px] font-black bg-white/10 px-1.5 py-0.5 rounded">GIF</span> Choisir un sticker
        </div>
        <button onClick={onClose} className="text-white/50 hover:text-white"><X size={14} /></button>
      </div>
      <div className="grid grid-cols-4 gap-1.5">
        {visibleGifs.map((g) => (
          <button
            key={g.url}
            onClick={() => onSend(g.url)}
            className="aspect-square rounded-lg overflow-hidden bg-black/40 hover:ring-2 hover:ring-[#005CFF] active:scale-95 transition"
            title={g.label}
            data-testid={`chat-gif-preset-${g.label}`}
          >
            <img
              src={g.url}
              alt={g.label}
              className="w-full h-full object-cover"
              loading="lazy"
              onError={() => setBrokenGifs((s) => ({ ...s, [g.url]: true }))}
            />
          </button>
        ))}
      </div>
      <div className="mt-3 pt-3 border-t border-white/10">
        <div className="text-[10px] uppercase tracking-widest text-white/40 mb-1">Ou coller une URL Giphy / Tenor</div>
        <div className="flex gap-1.5">
          <input
            type="url"
            value={customGifUrl}
            onChange={(e) => setCustomGifUrl(e.target.value)}
            placeholder="https://media.giphy.com/..."
            className="flex-1 bg-white/5 border border-white/10 rounded-lg px-2 py-1.5 text-xs outline-none"
            data-testid="chat-gif-url-input"
          />
          <button
            onClick={() => { onSend(customGifUrl.trim()); setCustomGifUrl(""); }}
            disabled={!customGifUrl.trim()}
            className="px-3 py-1.5 rounded-lg bg-[#005CFF] hover:bg-[#0047CC] disabled:opacity-40 text-xs font-semibold"
            data-testid="chat-gif-url-send"
          >
            Envoyer
          </button>
        </div>
      </div>
    </div>
  );
}
